<template>
  <div class="visaCmp full-height linear-main3">
    <ld-header
      @click-left="$router.push({ path: '/home' })"
      transparent
      white
    >
      {{ $t('A127','预订完成') }}
    </ld-header>

    <van-pull-refresh
      class="wrapper"
      v-model="isLoading"
      @refresh="getDetail"
    >
      <div class="white pad8">
        <van-row class="font-lg font24 mt5">
          <ld-icon
            :type="detail.isShowSs == 1 ? 'iconshenpi1' : 
              detail.isShowPay == 1 ? 'iconzhifu' :
              'icondingzuoshj-icon-Reser'"
            size="30"
            class="order-status__icon"
          />
          {{ detail.orderStatusRemark }}
        </van-row>
        <van-row class="font12 mt5">
          {{ detail.orderStatusRemarkDetail }}
        </van-row>
      </div>

      <div
        class="pad8" 
        v-if="detail.orderNo"
      >
        <van-row class="round-sm pad8 van-row bg-white">
          {{ $t('F001','订单号') }}：{{ detail.orderNo }}
          
          <router-link
            class="main-color fr"
            :to="`/visa/OrderDetail/${id}`"
          >
            {{ $t('B011','查看订单') }}
          </router-link>
        </van-row>

        <div class="round-sm mt5">
          <DetailPanel
            class="bg-white van-hairline--bottom"
            :detail="detail"
          >
            <van-row class="mt5">
              <label>出行日期：</label>
              {{ detail.tripDate }}
            </van-row>
            <van-row class="mt5">
              <label>{{ $t('F006','出行人') }}：</label>
              {{ detail.psgNameStr }}
            </van-row>
          </DetailPanel>
        </div>

        <ld-button
          class="mt5"
          detault
          to="/visa"
        >
          {{ $t('B012','继续预订') }}
        </ld-button>
      </div>

      <van-row
        v-if="detail.isShowApproval == 1"
        class="pad8 orange bg-lightYellow"
      >
        {{ $t('Warm','温馨提示：系统支持“多个行程合并送审”功能，您可以“继续预订”完其他行程后，再操作“送审”') }}。
      </van-row>
    </van-pull-refresh>


    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col
          span="11"
          :offset="1"
        >
          <span class="font10 red">&yen;</span>
          <span class="font24 red">{{ detail.totalPrice }}</span>
          <span class="font10 gray">{{ $t('E017','共') }}{{ detail.personList && detail.personList.length }}人</span>
          
          {{ $t('E006','明细') }}
          <van-icon
            name="arrow-up"
            class="vertical-middle"
            size="14"
          />
        </van-col>
        <van-col
          offset="4"
          span="8"
          class="pad5 text-right"
        >
          <ld-button
            main
            size="md"
            v-if="detail.isShowApproval == 1"
            @click.stop="btnClick('approval')"
          >
            {{ $t('B028','送审') }}
          </ld-button>

          <ld-button
            main
            size="md"
            v-else-if="detail.isShowPay==1"
            @click.stop="pay"
          >
            {{ $t('B014','支付') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      :order-type="detail.orderType"
      :order-id="id"
    /> -->
  </div>
</template>

<script>
import mixin from './detailMixin'

export default {
  name: 'VisaCmp',
  mixins: [mixin]
}
</script>

<style lang="less">
.visaCmp {

  .wrapper {
    height: calc(100vh - 96px);
  }

  p {
    margin: 0;
  }
  
  .pad5 {
    padding: 5px;
  }

  h3 {
    margin: 0;
    margin-bottom: 8px;
  }

  .pad8 {
    padding: 8px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .round-sm {
    overflow: hidden;
  }

  .order-status__icon {
    vertical-align: middle;
  }
}
</style>

